import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDeskLamp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDeskLamp"><Path d="M15.5521 3.5H8.44799C6.42312 3.5 4.51607 4.69753 3.98256 6.65085C3.64496 7.88694 3.45276 9.14928 3.51002 10.5H20.49C20.5472 9.14928 20.355 7.88695 20.0174 6.65088C19.484 4.69754 17.5769 3.5 15.5521 3.5Z" stroke="currentColor"/><Path d="M12 10.5V20.5" stroke="currentColor"/><Path d="M7.5 20.5H16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 10.5V16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDeskLamp;
